export enum APIEvents {
  REQUEST_COMPLETE = '@sydle/one-api:request-complete',
  REQUEST_INCOMPLETE = '@sydle/one-api:request-incomplete',
  REQUEST_COMPLETE_SUCCESS = '@sydle/one-api:request-complete-success',
  REQUEST_COMPLETE_ERROR = '@sydle/one-api:request-complete-error',
  EXPIRING_SESSION = '@sydle/one-api:expiring-session',
  UNAUTHORIZED = '@sydle/one-api:unauthorized',
  FORBIDDEN = '@sydle/one-api:forbidden',
  LANGUAGE_DID_CHANGE_EVENT = '@sydle/one-api:language-did-change',
  INVALID_TOKEN = '@sydle/one-api:invalid-token',
  LOGIN = '@sydle/one-api:login',
  LOGOUT = '@sydle/one-api:logout',
}
